/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ExpandInputs */

const en_common_expand = /** @type {(inputs: Common_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand`)
};

const id_common_expand = /** @type {(inputs: Common_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbesar`)
};

/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Common_ExpandInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const common_expand = /** @type {((inputs?: Common_ExpandInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ExpandInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_expand(inputs)
	return en_common_expand(inputs)
});